<template>
    <div>

      <navbar :title="fad" :box="box"/>
        <van-divider style="color:white">Siparişiniz Başarı ile alındı</van-divider>
      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import { Dialog } from 'vant';
import { Notify } from 'vant';
import {Toast} from 'vant';
import {router}  from '@/router';
import navbar from './nav'
export default {
  components:{
    navbar
  },
  data() {
    return {

      active:0,
      kart2:{
        no1:'4987',
        no2:'4972',
        no3:'3382',
        no4:'8554',
      },
      moka:{
          "cc_name":'',
          "cc_card_no": '',
          "cc_exp_mo": '02',
          "cc_exp_yr": "2022",
          "CvcNumber": "995",
          "sipno":"94505748676235",
          "total":0
      },
      Banka:{},
      payType:"cüzdan",
      posts:[],
      cuzdan:[],
      sepet:'',
      show:false,
      fad:"Ödeme",
      
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
     
      siparis:{
         sip_no:'',
         uye_kod:helper.settings.ayar().uye,
         tarih:helper.funcs.trtgosternoktali(new Date()),
         notu:'',
         fiyat:0,
         puan:0,
         kariyer_puan:0,
         gun:helper.settings.donem().gun,
         ay:helper.settings.donem().ay,
         yil:parseInt(helper.settings.donem().yil),
         odeme_sekli:''
      },
      kargo:{
        sip_no:'',
        id:0,
        adet:1,
        fiyat:0,
        kdv:0,
        puan:0,
        kpuan:0
      }

    };
  },
  computed: {
    totalCuzdan() {
      return this.cuzdan.reduce(
        (acc, item) => acc + item.toplam -  item.odenen,
        0
      );
    },      

  }, 
  created (){
   this.show = true
   userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {
      this.getProduct()
      this.cuzdanHesap();
      })
    .catch(err => {userService.logout()})
  },
    methods : {

      sipbasla(payType){
        Dialog.confirm({
        title: 'Onaylıyor musunuz ?',
        message:'Sipariş eklenecek',
        }).then(() => {
          this.show = true
          this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)
          .then(res=>{
            if(res.status){this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)}
            else{
              this.siparis.sip_no = res.no
               this.kargo.sip_no = res.no
                this.moka.sipno = res.no
                this.sipekle()
                  .then(()=>{ this.infoekle().then(()=> { this.sipupdate()})})
                  .catch(()=>{
                    this.sipekle()
                  })
            }
          })
        })
      },
      sipekle(){
        return new Promise((resolve, reject) => {
          helper.request.post('sipekle',this.siparis)
            .then((res)=>{
              resolve(res.no)
            })
            .catch(()=>{
              reject()
            })
        })
      },
      infoekle(){
        return new Promise((resolve, reject) => {
          var pros = 0
          var err = 0
          var items = JSON.parse(localStorage.getItem('ayuBox')) || [];
            this.posts.forEach(element => {
              let data = {
                sip_no:this.siparis.sip_no,
                urunid:element.id,
                adet:element.adet,
                fiyat:element.fiyat,
                kdv:element.kdv,
                puan:element.puan,
                kariyer_puan:element.kpuan
              }
              helper.request.post('infoekle',data)
              .then((res)=>{
                this.remove(items.baskets.findIndex(obj => obj.id===res.id))  
              })
              pros++ 
            });
            if(this.posts.length === pros){ resolve() }
        })
      },
      cuzdanHesap(){
        
      helper.request.get("paysCuzdan/"+this.uye_kod)
      .then(res => {
          this.cuzdan = res.results.sort(function(a,b){return new Date(a.yil,a.ay, 1) - new Date(b.yil, b.ay, 1)})
      })

      },
      sipupdate(){
        this.moka.cc_card_no = this.kart2.no1+''+this.kart2.no2+''+this.kart2.no3+''+this.kart2.no4
          if(this.siparis.odeme_sekli === "Kredi Kartı"){
           let url = "https://ayurlifeworld.com/panel/3d_check.php"//this.Url;'Accept': 'application/json'
            fetch(url, {
              method: 'POST',
             headers:{"Content-Type":"application/json; charset=UTF-8",},
              body: JSON.stringify(this.moka)
            })
            .then((res) => {
                return res.json();
            })
            .then((res) =>{

              //router.go(res.Data)
              console.log(res.Data)
            })
            .catch(function (error) {
              console.log(error)
              //swal("Hata ile Karşılaşıldı","",error);
            });
  
          }
          else{
            router.push('siparis/'+this.siparis.odeme_sekli+'/'+this.siparis.sipno)
          }
          // else if(this.siparis.odeme_sekli === "Cüzdan")
          // {
          //   let data = {
          //     sip_no : this.siparis.sip_no,
          //     durum_id:1,
          //     durum:'Başarılı Ödeme'
          //   }
          //   helper.request.post('sipupdate',data)
          //   .then(res => {
          //     Toast("Sipariş Ekleme Başarılı")
          //     this.show = false
          //   })
          //   .catch(()=>{
          //     Toast("Birşeyler ters gitti")
          //   })

          // } // cüzdana ödeme ekleme işlemi yapılacak          
          // else{
          //   let data = {
          //     sip_no : this.siparis.sip_no,
          //     durum_id:5, //1
          //     durum:'Ödeme Bekleyen Sipariş' //başarılı ödeme
          //   }
          //   helper.request.post('sipupdate',data)
          //   .then(res => { 
          //     this.show = false
          //     Toast("Sipariş Ekleme Başarılı")
          //     //router.push('/')
          //   })
          //   .catch((err)=>{
          //     Toast("Birşeyler ters gitti")
          //     this.show = false
          //   })
          // }

      },

      getProduct(){
        var pros = 0
        JSON.parse(localStorage.getItem('ayuBox')).baskets.forEach(element => {
          helper.request.get('urunler/'+element.id)
          .then(res =>{
            let data = {
                    fiyat:res.results[0].fiyat,
                    puan:res.results[0].puan,
                    kpuan:res.results[0].kariyer_puan,
                    adet:element.adet,
                    id:element.id,
                    kdv:res.results[0].kdv,
                  }
                this.posts.push(data)
               
                this.siparis.fiyat+=(data.adet*data.fiyat)
                this.siparis.puan+=(data.adet*data.puan)
                this.siparis.kariyer_puan+=(data.adet*data.kpuan)
          })
          .catch(err => {Notify({ type: 'danger', message: err.message });})
          pros++
         
        });

          if(JSON.parse(localStorage.getItem('ayuBox')).baskets.length === pros)
          {
            setTimeout(() => {
             if (this.siparis.fiyat<200) { this.kargohesap()}
             else{this.show = false}
            }, 1000);
 
          }
        
      },
      parabirimi(res){
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
      },
      sipno_kontrol(value){
      return new Promise((resolve, reject) => {
          helper.request.get("sipno/"+value)
          .then(res=>{
            resolve(res)
          })
      })
      },
      onClick(name) { this.siparis.odeme_sekli = name },
      kargohesap(){
        this.kargo.fiyat = 10
        this.moka.total = this.siparis.fiyat + 10 // sadece kredi kartına gönderilecek değer için
        this.posts.push(this.kargo)
        this.show = false
    },
      remove (index) {
                var items = JSON.parse(localStorage.getItem('ayuBox')) || [];
                items.baskets.splice(index,1)
                localStorage.setItem('ayuBox', JSON.stringify(items))
 
      },    
  } 
};
</script>
<style>
body{background:#00ac48}
  .para{font-size: 24px;}
  .delete-button {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/siparis.vue